<template>
	<div class="select-wrapper" :class="has_error?'errorous':''">
			<select v-model="input_value" :id="id" class="form-control" onchange=" this.dataset.chosen = this.value; " data-chosen="">
					<option value="" disabled selected>{{label}}</option>
					<option v-for="option in options" :value="option.value">{{	option.display_text }}</option>
			</select>
			<label :for="id">{{label}}</label>
	</div>
</template>
<script>
	export default {
		name: 'SimplementsSimpleSelect',
		props: {
			label: {
				type: String,
			},
			options: {
				type: Array
			},
			value: {
				type: String
			},
			has_error: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			id(){
				return 'simplement-'+this._uid
			}
		},
		data(){
			return {
				input_value: ''
			}
		},
		mounted(){
			this.input_value = this.value
		},
		watch: {
			// value(){
			// 	this.input_value = this.value
			// },
			input_value(){
				this.$emit('input', this.input_value)
			}
		},
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	select.form-control{
		border-radius: 8px !important;
		background: rgba(238, 238, 238, 0.93) !important;
		border: none !important;
		height: 56px !important;
	}
	select.form-control{
		-webkit-appearance: none;
		-moz-appearance: none;
		text-indent: 1px;
		text-overflow: '';
	}
	.select-wrapper{
		position: relative;
	}
	.select-wrapper:after{
		content: "";
		background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z" fill="%238D8D8D" fill-opacity="0.933333"/></svg>');
		width: 24px;
		height: 24px;
		display: block;
		position: absolute;
		right: calc(16px);
		top: 16px;
	}
	.select-wrap{
		width: 80% !important;
	}
	select[data-chosen=""]{
		color: #8D8D8DEE !important;
		font-size: 14px;
	}
	select + label{
		font-size: 10px;
		margin-top: -.5em;
		position: absolute;
		margin-top: -3.25rem;
		position: absolute;
		margin-left: 1.5em;
		opacity: .4;
		transition: all 0.5s;
	}
	select[data-chosen=""] + label{
		opacity: 0;
		font-size: 14px;
		margin-top: -2.5rem;
		margin-left: 1.125em;
		transition: all 0.5s;
		opacity: 0;
	}
	select{
		padding-top: 1rem;
		transition: all .5s;
	}
	select[data-chosen=""]{
		padding-top: .5rem;
	}
</style>